import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Установлен пароль по умолчанию", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400" }, "Смените пароль в настройках", -1)

import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultPasswordWarning',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiGroup, null, {
    default: _withCtx(() => [
      _createVNode(UiCard, { class: "default-password-warning" }, {
        default: _withCtx(() => [
          _createVNode(UiCell, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/settings/change-password'))),
            multiline: "",
            expandable: ""
          }, {
            left: _withCtx(() => [
              _createVNode(UiIcon, { icon: "ExclamationCircle" })
            ]),
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})